export default __webpack_public_path__ + "a5f6f2b.png";